module.exports = __webpack_public_path__ + "img/dog_11544.18264114.png";